import { render } from "./PlaceItem.vue?vue&type=template&id=3bf785da&scoped=true"
import script from "./PlaceItem.vue?vue&type=script&lang=js"
export * from "./PlaceItem.vue?vue&type=script&lang=js"

import "./PlaceItem.vue?vue&type=style&index=0&id=3bf785da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf785da"]])

export default __exports__